// extracted by mini-css-extract-plugin
export default {"default":"CustomButton_default__M6cjT","primary":"CustomButton_primary__+mkMa","outline_primary":"CustomButton_outline_primary__eOGf4"};